import React from 'react';
import SVG from 'react-inlinesvg';
import { ICONS } from 'src/utils/icon-urls.utils';

export function ScrollTop() {
	return (
		<div id="kt_scrolltop" className="scrolltop">
			<span className="svg-icon">
				<SVG src={ICONS.NAVIGATION}></SVG>
			</span>{' '}
		</div>
	);
}
